import React from 'react'

export default function CheckInSkeleton() {
    return (
        <div aria-hidden="true" className="flex flex-col gap-6 -mt-4 blur pointer-events-none select-none animate-pulse">
            <div className="h-5 w-4/5 rounded bg-lightBG" data-testid="check-in-subheader-skeleton" />
            <div className="flex flex-row gap-6">
                <div className="flex items-center gap-2">
                    <div className="h-5 w-10 rounded bg-lightBG" />
                    <div className="w-[120px] h-[120px] rounded-full border-[15px] border-lightBG shrink-0" />
                    <div className="h-5 w-10 rounded bg-lightBG" />
                </div>
                <div className="flex-1 flex flex-col gap-4">
                    {[0, 1].map((row) => (
                        <div key={row} className="flex flex-col">
                            <div className="h-6 w-3/4 rounded bg-lightBG" />
                            <div className="h-6 w-full rounded bg-lightBG" />
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex flex-row gap-8">
                {[0, 1].map((item) => (
                    <div key={item} className="flex items-center gap-2">
                        <div className="w-8 h-4 rounded bg-lightBG" />
                        <div className="w-40 h-5 rounded bg-lightBG" />
                    </div>
                ))}
            </div>
        </div>
    )
}
